import App from './App';

Vue.component(App.name, App);

// dn.one('mount', () => {
//   new Vue({
//     components: {
//       [App.name]: App,
//     },
//     el: '#pg-app',
//     parent: dn,
//   });
// });



// WEBPACK FOOTER //
// ./src/js/bible/myuniv/index.js